import type { TFunction } from 'i18next';
import * as yup from 'yup';

export const validationSchema = (t: TFunction) =>
  yup.object({
    name: yup.string().required(t('settings.validationError.nameRequired')),
    specificSettings: yup.object().shape({
      followUp: yup.object().shape({
        rootCauses: yup.array().of(
          yup.object().shape({
            isActive: yup.boolean().required(),
            name: yup
              .string()
              .required(t('settings.validationError.rootCauseNameRequired')),
            id: yup.number().optional(),
          }),
        ),
        customFields: yup.array().of(
          yup.object().shape({
            isActive: yup.boolean().required(),
            isMandatory: yup.boolean().required(),
            name: yup
              .string()
              .required(t('settings.validationError.customFieldNameRequired')),
            description: yup.string(),
            id: yup.number().optional(),
          }),
        ),
      }),
    }),
  });
